module.exports = __webpack_public_path__ + "img/freelancer-hiring-3.763228e3.png";